import { useFormContext } from 'react-hook-form';
import { Box } from '@mui/material';
import { DynamicFormConfig } from './dynamic-form.types';
import { DynamicField } from './utils/dynamic-field/dynamic-field';

type DynamicDocumentFormProps = {
  config: DynamicFormConfig;
};

export const DynamicForm = ({ config }: DynamicDocumentFormProps) => {
  const formMethods = useFormContext<Record<string, unknown>>();

  return (
    <Box display="flex" flex={1} flexDirection="column">
      {config.items.map((field) => (
        <DynamicField key={field.key} field={field} control={formMethods.control} />
      ))}
    </Box>
  );
};
